import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import { FaSignal, FaChartLine, FaListAlt, FaCheckCircle, FaMobileAlt, FaQuestion } from 'react-icons/fa';
import './styles/container.css';


class Container extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="container-div col-sm-12 col-md-12 col-12" style={{padding: "0px"}}>
        <div className = "container-btn-div">
          <Link to={`${process.env.PUBLIC_URL}/dashboard/bmi/`}><button><span className = "container-btn-icon"><FaSignal /></span><br/>{this.props.Translator["dashboard_metrics_button"]}</button></Link>
          <Link to={`${process.env.PUBLIC_URL}/dashboard/growth-chart/`}><button><span className = "container-btn-icon"><FaChartLine /></span><br/>{this.props.Translator["dashboard_growth_chart_button"]}</button></Link>
          <Link to={`${process.env.PUBLIC_URL}/dashboard/feeding/`}><button><span className = "container-btn-icon"><FaListAlt /></span><br/>{this.props.Translator["dashboard_feeding_advice_button"]}</button></Link>
          <Link to={`${process.env.PUBLIC_URL}/dashboard/past-advice/`}><button><span className = "container-btn-icon"><FaCheckCircle /></span><br/>{this.props.Translator["dashboard_nutritional_advice_button"]}</button></Link>
          <Link to={`${process.env.PUBLIC_URL}/dashboard/contact-us/`}><button><span className = "container-btn-icon"><FaMobileAlt /></span><br/>{this.props.Translator["dashboard_contact_us_button"]}</button></Link>
          <Link to={`${process.env.PUBLIC_URL}/dashboard/faqs/`}><button><span className = "container-btn-icon"><FaQuestion /></span><br/>{this.props.Translator["dashboard_faqs_button"]}</button></Link>
        </div>
      </div>
    );
  }
}

export default Container;